import EtablissementConventionCode from '@/generated/controls/etablissement/EtablissementConventionCode.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementConventionCode
})
